import {HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {
  CallControlServiceInterface,
  CallDto,
  CallTypeResponse,
  ClickToCallResponse,
  Configuration,
  GetActiveCallsResponse,
  GetEndUserCallLogResponse,
  Response,
  TransferCallResponse,
  TransferDto
} from '@gt-api';
import {Observable, of} from 'rxjs';

@Injectable()
export class CallControlServiceStub implements CallControlServiceInterface {
  defaultHeaders: HttpHeaders = new HttpHeaders();
  configuration: Configuration;

  public clickToCall2(organization?: string, login?: string, caller?: string, callee?: string): Observable<ClickToCallResponse> {
    return of({code: 200});
  }

  public clickToCallExtended1(
    organization?: string,
    login?: string,
    mainNumber?: string,
    queueId?: string,
    agent?: string,
    callee?: string,
    displayNumber?: string
  ): Observable<ClickToCallResponse> {
    return of({code: 200});
  }

  public clickToCallWithDisplayNumber1(
    organization?: string,
    login?: string,
    caller?: string,
    callee?: string,
    displayNumber?: string
  ): Observable<ClickToCallResponse> {
    return of({code: 200});
  }

  public clickToCallWithDto1(organization?: string, login?: string, body?: CallDto): Observable<ClickToCallResponse> {
    return of({code: 200});
  }

  public connectAtoC1(organization?: string, login?: string): Observable<any> {
    return of({code: 200});
  }

  public getActiveCalls2(organization?: string, login?: string): Observable<GetActiveCallsResponse> {
    const response: GetActiveCallsResponse = {
      code: 200,
      calls: []
    };
    return of(response);
  }

  public getCallType1(organization?: string, login?: string, caller?: string, callee?: string): Observable<CallTypeResponse> {
    const response: CallTypeResponse = {
      code: 200,
      imgCall: false,
      mspCall: false
    };
    return of(response);
  }

  public getEndUserCallLog1(
    organization?: string,
    login?: string,
    from?: string,
    to?: string,
    entriesPerPage?: number,
    page?: number
  ): Observable<GetEndUserCallLogResponse> {
    const response: GetEndUserCallLogResponse = {
      code: 200,
      entriesPerPage: 20,
      totalLogEntries: 20,
      totalPages: 1,
      callLog: [
        {
          callStart: 1494499207000 as any,
          duration: 1,
          peerNumber: '4791901723',
          triggerPoint: 2,
          cause: 100,
          firstName: null,
          lastName: 'Ukjent bruker'
        },
        {
          callStart: 1486980279000 as any,
          duration: 60,
          peerNumber: '4791901723',
          triggerPoint: 2,
          cause: 100,
          firstName: null,
          lastName: 'Ukjent bruker'
        }
      ]
    };
    return of(response);
  }

  public transferCall2(
    organization?: string,
    login?: string,
    caller?: string,
    callee?: string,
    transferee?: string
  ): Observable<TransferCallResponse> {
    const response: TransferCallResponse = {
      code: 200
    };
    return of(response);
  }

  public transferCallWithDto1(organization?: string, login?: string, body?: TransferDto): Observable<TransferCallResponse> {
    const response: TransferCallResponse = {
      code: 200
    };
    return of(response);
  }

  connectCalls1(organization?: string, login?: string, extraHttpRequestParams?: any): Observable<Response> {
    return of({code: 200});
  }

  disconnectCall2(
    sessionId: number,
    intendedLeg: string,
    organization?: string,
    login?: string,
    extraHttpRequestParams?: any
  ): Observable<Response> {
    return of({code: 200});
  }

  toggleCall2(
    sessionId: number,
    intendedLeg: string,
    organization?: string,
    login?: string,
    extraHttpRequestParams?: any
  ): Observable<Response> {
    return of({code: 200});
  }
}
